import { render, staticRenderFns } from "./transfer-apply-detail.vue?vue&type=template&id=ddc78960&"
import script from "./transfer-apply-detail.vue?vue&type=script&lang=js&"
export * from "./transfer-apply-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports